import { CompanyDisplayLabels } from '@run-diffusion/shared';

/**
 * Tooltip and snackbar copy for when the SCIM IdP manages membership and roles
 * (company.sso.scimProvisioningEnabled). Takes the company's display labels,
 * the way COMPANY_USER_ROLE_PERMISSION_DATA(displayLabels) does: a company that
 * renamed its teams must not read the hardcoded word here. The label opens the
 * sentence, so its first letter is capitalised.
 */
export function scimProvisioningMembershipTooltip (displayLabels: CompanyDisplayLabels | null | undefined): string {
	const label: string = ((displayLabels && displayLabels.team) || 'Team').trim() || 'Team';
	const teamLabel: string = label.charAt(0).toUpperCase() + label.slice(1);
	return `${teamLabel} membership and role assignment are managed by your SCIM identity provider. Change users and roles there.`;
}
